import sanityClient from '@sanity/client';
import imageUrlBuilder from '@sanity/image-url';

export const client = sanityClient({
  projectId: 'k1hk8k3x',
  dataset: 'production',
  apiVersion: '2022-02-01',
  useCdn: true,
  token: 'skaclGRTIbFSWd1yt1gSiyrf1uB0nyIQ6hJMB6qjq3Xiat6n5Y3kXhZMfTdy2aA3rXbZ1Votar5yd6iSv0oBy2oBXzhyvpoDCrJnGQuu7GOpl0vwc4Yi6D5zfLIOc8hu7qTpUyzNKVlurKIRkDX5bQwee8KxQHKjbU8Rqk8azbK9cBqvz2ft',
});

const builder = imageUrlBuilder(client);

export const urlFor = (source) => builder.image(source);